export default (element_name, label, name) => {
  return `f-${element_name}-${name ? `${name}-` : ""}${label
    ?.replace(" ", "-")
    ?.toLowerCase()}`;
};
